import React from "react";
import PropTypes from "prop-types";

// @mui material components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import { Divider } from "@mui/material";

function StepIndicator({ steps, activeStep }) {
  return (
    <MDBox display="flex" alignItems="center" justifyContent="center" my={4} mx={3} flexWrap="wrap">
      {steps.map((step, index) => (
        <React.Fragment key={step.key}>
          <MDBox display="flex" flexDirection="column" alignItems="center" mx={2} my={1}>
            <MDBox
              width="48px"
              height="48px"
              borderRadius="50%"
              bgColor={index <= activeStep ? "info" : "secondary"}
              display="flex"
              alignItems="center"
              justifyContent="center"
              mb={1}
            >
              <Icon fontSize="medium" color="white">
                {step.icon}
              </Icon>
            </MDBox>
            <MDTypography
              variant="caption"
              fontWeight="regular"
              color={index <= activeStep ? "text" : "secondary"}
              textAlign="center"
            >
              {step.label}
            </MDTypography>
          </MDBox>
          {index < steps.length - 1 && (
            <MDBox flexGrow={1} display="flex" alignItems="center" mx={1} maxWidth="100px">
              <Divider orientation="horizontal" sx={{ flexGrow: 1, borderColor: index < activeStep ? "info.main" : "secondary.main", borderWidth: "1px" }} />
            </MDBox>
          )}
        </React.Fragment>
      ))}
    </MDBox>
  );
}

StepIndicator.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default StepIndicator;










